import React from "react";
import styled from "@emotion/styled";

import ParkkiTheme from "themes/ParkkiTheme";
import AreaDoughnutLayout from "../AreaDoughnutLayout";
import PointDoughnutLayout from "../PointDoughnutLayout";

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 200px;
  height: 100%;
`;

const TitleContainer = styled.div`
  font-size: ${ParkkiTheme.fontSizes.small};
  font-weight: bold;
  margin-bottom: ${ParkkiTheme.spacings.small};
`;

function InOutDistribution({ disabled, stats, title, type }) {
  return (
    <Container>
      <TitleContainer>{title.toUpperCase()}</TitleContainer>
      {type === "area" ? (
        <AreaDoughnutLayout disabled={disabled} stats={stats} />
      ) : (
        <PointDoughnutLayout stats={stats} />
      )}
    </Container>
  );
}

export default InOutDistribution;
